import React from "react";
import { Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./App.css";
import Navigation from "./components/view/homePage/Navigation";
import Hero from "./components/view/homePage/Hero";
import AboutUs from "./components/view/homePage/AboutUs";
import Portfolio from "./components/view/homePage/Portfolio";
import Service from "./components/view/homePage/Service";
import Work from "./components/view/homePage/Work";
// import ShopModule from "./components/view/homePage/ShopModule";
import Cooperation from "./components/view/homePage/Cooperation";
import FAQ from "./components/view/homePage/FAQ";
import Contact from "./components/view/homePage/Contact";
import Footer from "./components/view/homePage/Footer";
import CookieBanner from "./components/view/cookies/CookieBanner";
import CookieSettings from "./components/view/cookies/CookiesSettings";
import CookiesPolicy from "./components/view/cookies/CookiesPolicy";
import PrivacyPolicy from "./components/view/privacyPolicy/privacyPolicy";
import Team from "./components/view/homePage/Team";
import WelcomePage from "./components/view/shopPage/WelcomePage";
import Web from "./components/view/webService/Web";
import Training from "./components/view/trainingService/Training";
import SQLTraining from "./components/view/trainingService/SQLTraining";
import LibreOfficeTraining from "./components/view/trainingService/LibreOfficeTraining";
import TrainingForAdults from "./components/view/trainingService/TrainingForAdults";
import ScrollToTopButton from "./components/ScrollToTopButton";
import Seo from "./components/Seo";
import ErrorHosting from "./components/error/ErrorHosting";

function App() {
  const location = useLocation();

  return (
    <>
      {location.pathname === "/" && (
        <Seo
          title="Tworzenie stron internetowych i szkolenia informatyczne"
          description="Tworzymy nowoczesne strony internetowe od podstaw oraz prowadzimy szkolenia informatyczne dla osób prywatnych, firm i instytucji."
          canonical="/"
        />
      )}
      <Navigation />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <AboutUs />
              <Portfolio />
              <Service />
              <Work />
              {/* <ShopModule /> */}
              <Cooperation />
              <FAQ />
              <Contact />
            </>
          }
        />
        <Route path="/team" element={<Team />} />
        <Route path="/shop" element={<WelcomePage />} />

        <Route path="/training" element={<Training />} />

        <Route path="/training/sql" element={<SQLTraining />} />
        <Route
          path="/training/libreOfficeTraining"
          element={<LibreOfficeTraining />}
        />
        <Route
          path="/training/cyfrowy-senior"
          element={<TrainingForAdults />}
        />

        <Route
          path="/web"
          element={
            <>
              <Web />
            </>
          }
        />

        <Route path="/error" element={<ErrorHosting />} />
      </Routes>
      <ScrollToTopButton />
      <Footer />
      <CookieBanner />
      <CookieSettings />
      <CookiesPolicy />
      <PrivacyPolicy />
    </>
  );
}

export default App;
